import { render, staticRenderFns } from "./trigger-condition-config.vue?vue&type=template&id=2c064bcc"
import script from "./trigger-condition-config.ts?vue&type=script&lang=js&external"
export * from "./trigger-condition-config.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports